import Vue from 'vue'
import axios from 'axios';

//sistema

Vue.prototype.$listarManifestos = async () => {
  try {
    let res = await axios.get('manifestacaos', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$listarManifestosPorDepartamento = async (id) => {
  try {
    let res = await axios.get('manifestacaos/departamento/'+id, {});
    return res.data;
  } catch (e) {
    throw e;
  }
}


//fotos de manifestações
Vue.prototype.$ListarFotos = async (uuid) =>{
  try {
    let res = await axios.get('fotos/manifestacao/'+uuid,{});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$ativarManifesto = async (uuid,abertura,us) => {
  try {
    let tipo;
    tipo = 'ADM';

    let res = await axios.post('manifestacaos/'+uuid+'/mudar/'+ abertura,{
      tipo_usuario: tipo,
      usuario: us,
    });

    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$conversaManifesto = async (manifestacao,cidadao,usuariosistema,assunto,tipo,conversa_sistema) => {
  try {
    let res = await axios.post('conversa/manifestacao/'+manifestacao+'/'+cidadao+'/'+ usuariosistema,{
      assunto: assunto,
      tipo: tipo,
      conversa_sistema: conversa_sistema
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$ListarConversaId = async (uuid) => {
  try {
    let res = await axios.get('conversa/manifestacao/id/'+uuid, {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$ListarConversaIdSistema = async (uuid) => {
  try {
    let res = await axios.get('conversa/manifestacao/sistema/id/'+uuid, {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$movimentarDepartamento = async (uuid,secretaria,usuario) => {
  try {
    let res = await axios.post('manifestacaos/movimentacao/'+uuid+'/secretaria/'+secretaria, {
      id:usuario
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}


Vue.prototype.$ouvidorManifestoStore = async (manifest) => {
  try {
    let res = await axios.post('conversa/manifestacao/',{
      assunto: assunto,
      tipo: tipo,
      conversa_sistema: conversa_sistema
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$manifestarAnonimoComOuvidor = async (manifesto) =>{
  try { 
    let res = await axios.post('/manifestacaos',{
        anonimo: 1,
        id_usuario: 0,
        tipo_usuario: 'cidadao',
        tipo_assunto: manifesto['tipo'],
        secretaria: manifesto['secretaria'],
        assunto: manifesto['assunto'],
        conteudo: manifesto['descricao'],
        rua: manifesto['rua'],
        numero: manifesto['numero'],
        bairro: manifesto['bairro'],
        complemento: manifesto['complemento'],
        ouvidor_id: manifesto['ouvidor_id'],
    });
    return res.data;
  } catch (e) {
    throw e;
  }  
}

